import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PlaceOrderModalComponent } from './place-order-modal.component';
import { PlaceOrderModalService } from './place-order-modal.service';
import { ModalModule } from 'ngx-bootstrap/modal';
import { PlaceOrderSchoolModule } from './school/school.module';
import { PlaceOrderSmsModule } from './sms/sms.module';
import { PlaceOrderCrawlModule } from './crawl/crawl.module';

@NgModule({
  declarations: [PlaceOrderModalComponent],
  imports: [
    CommonModule,
    ModalModule.forRoot(),
    PlaceOrderSchoolModule, PlaceOrderSmsModule, PlaceOrderCrawlModule
  ],
  providers:[PlaceOrderModalService],
  entryComponents: [PlaceOrderModalComponent],
})
export class PlaceOrderModalModule { }
